import React, { Component } from "react";
import "./style.scss";
// import { Appointments, TreatmentHistory, PurchaseHistory, PersonalDetails, Favourites } from './Details'
import classnames from "classnames";

import { TableWrapper } from "component/common";
import { getCommonApi } from "redux/actions/common";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { withTranslation } from "react-i18next";
import MGMDownlinelist from "redux/reducer/customerPlus";

export class ReferralRewardListingClass extends Component {
  state = {
    activeTab: "",
    isOpenTreatmentDone: false,
    isActiveTab: "detail",
    oldaccountHeader: [
      {
        label: "Site Code ",
        width: "100px",
        divClass: "justify-content-left text-center",
      },
      {
        label: "Date ",
        width: "100px",
        divClass: "justify-content-center text-center",
      },
      {
        label: "Description",
        width: "100px",
        divClass: "justify-content-center text-center",
      },

      {
        label: "Invoice",
        width: "50px",
        divClass: "justify-content-center text-center",
      },
      {
        label: "Type",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-center text-center",
      },
      {
        label: "Source",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-center text-center",
      },
      {
        label: "Points",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-center text-center",
      },
      {
        label: "Total points",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-center text-center",
      },
    ],

    oldDetailList: [],

    isLoading: false,
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
    this.getOldDetailList();
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    this.getOldDetailList();
  }

  handleOpenDetail = async (data, tab) => {
    let { activeTab } = this.state;
    activeTab = tab;

    await this.setState({
      activeTab,
    });
    // if (tab === "detail") {
    //   this.getDetailList(data.id);
    // } else {
    this.getOldDetailList(data.id);
    // }
  };

  getOldDetailList = (id) => {
    this.props
      .getCommonApi(
        `customerpointsaccount/Getrefferalpoints/?cust_id=${this.props.id}&page=1&limit=12`
      )
      .then((key) => {
        let { data, header_data } = key;
        let { oldaccountHeader, oldDetailList } = this.state;
        oldDetailList = data?.dataList;
        console.log(data, "downline");
        console.log(oldDetailList, "olddetaillist");

        // oldaccountHeader = header_data;
        this.setState({ oldDetailList });
        this.setState({
          isLoading: false,
        });
      });
  };

  handleBack = () => {
    let { activeTab } = this.state;
    activeTab = "";
    this.setState({
      activeTab,
      DetailList: [],
    });
    this.getOldDetailList();
  };

  render() {
    let { oldDetailList, oldaccountHeader, isLoading } = this.state;

    let { t } = this.props;
    return (
      <div className="treatment-account mt-5">
        <div className="col-12">
          <div className="table">
            <TableWrapper
              headerDetails={oldaccountHeader}
              queryHandler={this.handlePagination}
            >
              {isLoading ? (
                <tr>
                  <td colSpan="12">
                    <div class="d-flex mt-5 align-items-center justify-content-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : oldDetailList && oldDetailList.length > 0 ? (
                oldDetailList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className="text-left">{item.site_code}</div>
                      </td>
                      <td>
                        <div className="text-left">{item.customer_code}</div>
                      </td>
                      <td>
                        <div className="text-left">{item.customer_name}</div>
                      </td>
                      <td>
                        <div className="text-left">
                          {item.customer_referenceno}
                        </div>
                      </td>
                      <td>
                        <div className="text-left">{item.dateofjoin}</div>
                      </td>

                      <td>
                        <div className="text-left">{item.level}</div>
                      </td>
                      <td>
                        <div className="text-left">{item.level}</div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="12">
                    <div class="d-flex fs-18 align-items-center justify-content-center">
                      No data available
                    </div>
                  </td>
                </tr>
              )}
              {isLoading ? (
                <tr>
                  <td colSpan="12">
                    <div class="d-flex mt-5 align-items-center justify-content-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : (
                ""
              )}
            </TableWrapper>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
    },
    dispatch
  );
};

export const ReferralRewardListing = withTranslation()(
  connect(null, mapDispatchToProps)(ReferralRewardListingClass)
);
